import { render, staticRenderFns } from "./CampaignsTwoWay.vue?vue&type=template&id=cd7d0580"
import script from "./CampaignsTwoWay.vue?vue&type=script&lang=js"
export * from "./CampaignsTwoWay.vue?vue&type=script&lang=js"
import style0 from "./CampaignsTwoWay.vue?vue&type=style&index=0&id=cd7d0580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports